import { Toast, ToastType } from 'types/toasts'
import {
  DISABLED_INFO_IS_NOT_FANTOM,
  DISABLED_INFO_IS_NOT_ETH,
  DISABLED_INFO_ALREADY_CLAIMED,
  DISABLED_INFO_HOLDER_ACTIONS,
  DISABLED_INFO_INVESTING_EPOCH,
  DISABLED_INFO_NOT_EXISTS,
} from './ownedCrypto.constants'

export const getClaimRateInfo = (
  claimed = 100,
  holded = 0
) => `Each distribution, from your POKT rewards:
  - ${claimed}% will be claimable in USDC.
  - ${holded}% will be kept in the Pocket Network. Then, Compound and/or Sweep your POKT reward.
  `
export const getClaimWarningToast = (claimed = 100, holded = 0): Toast => ({
  title: 'Warning',
  message: `For the following epoch's reward distributions, ${claimed}% of your POKT rewards will be cashed to USDC for you to claim, while the remaining ${holded}% will be holded in POKT.`,
  type: ToastType.Warning,
})

export const getDisabledInfo = (
  isNotFantom?: boolean,
  exists?: boolean,
  actionsDisabled?: boolean,
  investingEpoch?: boolean,
  alreadyClaimed?: boolean
): string => {
  if (isNotFantom) {
      return DISABLED_INFO_IS_NOT_FANTOM
  }
  if (actionsDisabled) {
    return DISABLED_INFO_HOLDER_ACTIONS
  }

  if (!exists) {
    return DISABLED_INFO_NOT_EXISTS
  }

  if (investingEpoch) {
    return DISABLED_INFO_INVESTING_EPOCH
  }

  if (alreadyClaimed) {
    return DISABLED_INFO_ALREADY_CLAIMED
  }

  return ''
}

export const getDisabledInfoEth = (
   isNotEthereumAndReady?: boolean
): string => {
    if (isNotEthereumAndReady) {
        return DISABLED_INFO_IS_NOT_ETH
    }
    return ''
}

export const timeout = (
    ms: number
) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const fetchWpoktMintData = async (
    recipient: string,
    active: boolean
) => {
    const corsProxy = 'https://corsproxy.io/?url='
    const uri = (active) ? 'https://wpokt.network/api/mints/active?recipient=' : 'https://wpokt.network/api/mints/all?recipient='

    const response = await fetch(corsProxy + encodeURIComponent(uri + recipient), {
        method: "GET"
    })
    const body = await response.json();
    return body
}